// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"4519":"d06e2d48","5565":"93d75d34"}[chunkId] + ".chunk.css";
};